import React from 'react';
import {
  EVAlert, makeStyles, EVGrid, EVDialog, EVTypography, EVButton,
} from 'lib/components';
import PropTypes from 'prop-types';
import useMediaQuery from 'hooks/useMediaQuery';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  closeButton: {
  },
  dialogContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '24px',
    gap: '20px',
  },
  titleContainer: {
    display: 'flex',
    flex: '1',
    justifyContent: 'space-between',
    padding: '0px',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    '@media(max-width: 640px)': {
      width: '100%',
      flexDirection: 'column',
    },
  },
  title: {
    fontSize: '21px',
    fontWeight: '600',
    alignSelf: 'center',
  },
  dialogContent: {
    border: `1px solid ${theme.evPalette.rose[900]}`,
    borderRadius: '4px',
  },
  dialogAlert: {
    padding: '5px 12px',
    backgroundColor: '#F7DCE7',
    '&>.myev-MuiAlert-message': {
      color: theme.evPalette.charcoal[900],
    },
    '&>.myev-MuiAlert-icon': {
      padding: '10px 0',
      color: theme.evPalette.rose[900],
    },
    '&>.myev-MuiAlert-action': {
      alignItems: 'start',
    },
  },
}));

function ValidationErrorDialogBox({ mapPinValidationError, setMapPinValidationError }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(640);
  const handleClose = () => setMapPinValidationError(false);
  return (
    <EVDialog
      open={mapPinValidationError}
    >
      <EVGrid className={classes.dialogContainer}>
        <EVGrid className={classes.titleContainer}>
          <EVTypography className={classes.title}>{t('address_verification__map__validation_error')}</EVTypography>
        </EVGrid>
        <EVGrid data-testid="validation-alert" className={classes.dialogContent}>
          <EVAlert severity="error" className={classes.dialogAlert}>
            {t('address_verification__map__validation_error_alert')}
          </EVAlert>
        </EVGrid>
        <EVGrid className={classes.actions}>
          <EVButton onClick={handleClose} color="primary" variant={isMobile ? 'contained' : 'text'} id="continue-btn">
            {t('address_verification__validation_dialog__continue')}
          </EVButton>
        </EVGrid>
      </EVGrid>
    </EVDialog>
  );
}

ValidationErrorDialogBox.propTypes = {
  mapPinValidationError: PropTypes.bool.isRequired,
  setMapPinValidationError: PropTypes.func.isRequired,
};

export default ValidationErrorDialogBox;
